import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  isGetBookingLoading: false,
  isGetUpcomingBookingLoading: false,
  getUpcomingBookingResponse: null,
  getCalendarBookingResponse: null,
  isGetCalendarBookingLoading: false,
  createGoogleEvent: null,
  isCreateGoogleEventLoading: false,
  isCancelGoogleEventLoading: false,
  isAddCalendarBookingLoading: false,
  isCancelCalendarBookingLoading: false,
  calendarBooking: null,
  isAccessTokenValidLoading: false,
  accessTokenValid: null,
}

const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    // getBooking
    getBookingLoading: (state) => {
      state.isGetBookingLoading = true
    },
    getBookingSuccess: (state, { payload }) => {
      state.isGetBookingLoading = false
      state.bookings = payload
    },
    getBookingFailure: (state) => {
      state.isGetBookingLoading = false
    },
    // getUpcomingBooking
    getUpcomingBookingLoading: (state) => {
      state.isGetUpcomingBookingLoading = true
    },
    getUpcomingBookingSuccess: (state, { payload }) => {
      state.isGetUpcomingBookingLoading = false
      state.getUpcomingBookingResponse = payload
    },
    getUpcomingBookingFailure: (state) => {
      state.isGetUpcomingBookingLoading = false
    },

    // getCalendarBooking
    getCalendarBookingLoading: (state) => {
      state.isGetCalendarBookingLoading = true
    },
    getCalendarBookingSuccess: (state, { payload }) => {
      state.isGetCalendarBookingLoading = false
      state.getCalendarBookingResponse = payload
    },
    getCalendarBookingFailure: (state) => {
      state.isGetCalendarBookingLoading = false
    },

    // google event
    createGoogleEventLoading: (state) => {
      state.isCreateGoogleEventLoading = true
    },
    createGoogleEventSuccess: (state, { payload }) => {
      state.isCreateGoogleEventLoading = false
      state.createGoogleEvent = payload
    },
    createGoogleEventFailure: (state) => {
      state.isCreateGoogleEventLoading = false
    },


    cancelGoogleEventLoading: (state) => {
      state.isCancelGoogleEventLoading = true
    },
    cancelGoogleEventSuccess: (state, { payload }) => {
      state.isCancelGoogleEventLoading = false
      state.createGoogleEvent = payload
    },
    cancelGoogleEventFailure: (state) => {
      state.isCancelGoogleEventLoading = false
    },

    // google event
    addCalendarBookingLoading: (state) => {
      state.isAddCalendarBookingLoading = true
    },
    addCalendarBookingSuccess: (state, { payload }) => {
      state.isAddCalendarBookingLoading = false
      state.calendarBooking = payload
    },
    addCalendarBookingFailure: (state) => {
      state.isAddCalendarBookingLoading = false
    },

    cancelCalendarBookingLoading: (state) => {
      state.isCancelCalendarBookingLoading = true
    },
    cancelCalendarBookingSuccess: (state, { payload }) => {
      state.isCancelCalendarBookingLoading = false
      state.calendarBooking = payload
    },
    cancelCalendarBookingFailure: (state) => {
      state.isCancelCalendarBookingLoading = false
    },

    // access token
    isAccessTokenValidLoading: (state) => {
      state.isAccessTokenValidLoading = true
    },
    isAccessTokenValidSuccess: (state, { payload }) => {
      state.isAccessTokenValidLoading = false
      state.accessTokenValid = payload
    },
    isAccessTokenValidFailure: (state) => {
      state.isAccessTokenValidLoading = false
    },
  },
})

export const {
  getBookingFailure,
  getBookingLoading,
  getBookingSuccess,
  getUpcomingBookingFailure,
  getUpcomingBookingLoading,
  getUpcomingBookingSuccess,
  getCalendarBookingLoading,
  getCalendarBookingSuccess,
  getCalendarBookingFailure,
  createGoogleEventLoading,
  createGoogleEventSuccess,
  createGoogleEventFailure,
  cancelGoogleEventLoading,
  cancelGoogleEventSuccess,
  cancelGoogleEventFailure,
  addCalendarBookingLoading,
  addCalendarBookingSuccess,
  addCalendarBookingFailure,
  cancelCalendarBookingLoading,
  cancelCalendarBookingSuccess,
  cancelCalendarBookingFailure,
  isAccessTokenValidLoading,
  isAccessTokenValidSuccess,
  isAccessTokenValidFailure,
} = bookingSlice.actions

export default bookingSlice.reducer
